import React, {useState} from 'react';
import {
    apollo_useStyles,
    getModalStyle
} from "../../atom/Apollo_styles";
import {ApolloContext} from "../../atom/Apollo_Context";
import {
    resignin_api,
    home_path,
} from "../../atom/Apollo_links";

import {ApolloMessage } from "../../atom/Apollo_Mesasge";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {useForm} from "react-hook-form";

import {useHistory } from "react-router-dom";

import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";

import Grid from "@material-ui/core/Grid";
import {ApolloPassword} from "../../atom/Apollo_Password";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";

export interface resignparam {
    open: boolean;
    email:string;
    onetimeToken: string;
    handleClose: () => void;
}

export const ResigninDialog: React.FC<resignparam> = ( { open,email,onetimeToken, handleClose } ) => {

    const classes = apollo_useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const { state ,dispatch } = React.useContext(ApolloContext)
    const { setmsg } = React.useContext(ApolloMessage)
    let history = useHistory();

    const { register, handleSubmit, errors, formState } = useForm<FormData>();
    const [ dspmsg, setMessage ] = useState("パスワードを再設定してください") ;

    //ボタンをクリック時処理
    const onSubmit = handleSubmit(( data : any ) => {

        const urlstring = resignin_api;
        //let apiname= "resignin"
        //Ajax コール
        ApolloAxios.post(urlstring, {
            id: email,
            oldPassword: data.oldpassword,
            newPassword: data.newpassword,
            ConfirmNewPassword: data.confirmpassword,
            OnetimeToken: onetimeToken,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.accesstoken}`,
            }
        }).then( response => {
            //Body に付与される認可情報などをContextへセット
            //console.log(response.data)
            dispatch({
                type: "setAccount",
                payload: {
                    ...state,
                    userprofile: response.data.userprofile,
                    authorization: response.data.authorization,
                    current: response.data.current,
                    apolloList: response.data.apolloList,
                    accesstoken: response.data.accesstoken,
                }
            })
            history.push(home_path);
        })
        .catch(function (error) {
            setmsg({
                type: "all",
                payload: {
                    ...data,
                    open: error.open,
                    type: error.type,
                    message: error.errmsg,
                    loading: false
                }
            });
            if (error.redirect != "") {
                const url = error.redirect ;
                history.push( url );
            }
        });
    });

    return (
        <Modal
            aria-labelledby="resignin-modal"
            aria-describedby="resignin-modal-description"
            open={open}
            onClose={handleClose}
        >
            <div style={modalStyle} className={classes.paper}>
                <React.Fragment>
                    <Card className={classes.signinpaper}>
                        <CardContent>
                            <form className={classes.form} noValidate>
                                <Typography component="h2" variant="h5">
                                    { dspmsg }
                                </Typography>
                                <Typography variant='caption' color='textSecondary'>
                                    ※一部のブラウザでは、パスワードなどのフォーム入力値を強制的に保存する場合があります。<br/>
                                    　共用端末ではパスワードなどを入力しないことを推奨いたします。
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <ApolloPassword register={register}
                                                        errors={errors}
                                                        id={"oldpassword"}
                                                        name={"oldpassword"}
                                                        label={"旧パスワード"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ApolloPassword register={register}
                                                        errors={errors}
                                                        id={"newpassword"}
                                                        name={"newpassword"}
                                                        label={"新パスワード"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ApolloPassword register={register}
                                                        errors={errors}
                                                        id={"confirmpassword"}
                                                        name={"confirmpassword"}
                                                        label={"確認パスワード"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                            onClick={onSubmit}
                                            disabled={formState.isSubmitting}
                                        >
                                            Sign In
                                        </Button>
                                        </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </React.Fragment>
            </div>
        </Modal>
    )
}

// @ts-ignore
export default ResigninDialog;

